import { Image, TouchableOpacity } from 'react-native';

import { cn, Heading } from '@altify/components';
import { Language } from '@altify/utils';
import { NewsBannerType } from 'types/newsbanner';
import close from './assets/close.svg'

export const BannerViewItem = ({
  mappedBanner,
  onPress,
  onClose,
  className,
  language
}: {
  mappedBanner: NewsBannerType;
  onPress: () => void;
  onClose?: () => void;
  className?: string
  language: Language
}) => {
  
  return (
    <TouchableOpacity
        onPress={onPress}
        className={cn(
          'bg-[#EAEBED] flex flex-row flex-grow items-center rounded-xxl px-3 mx-3 h-full mt-0 overflow-hidden',
          className,
        )}>
        <div className='flex flex-col flex-grow flex-1'>
          <Heading level={1} className={cn('text-[#696969]', mappedBanner?.titleClassName)}>
            {mappedBanner?.heading[language]}
          </Heading>
          <Heading level={3} className={cn('text-[#A7A7A7]', mappedBanner?.subtitletitleClassName)}>
            {mappedBanner?.subHeading[language]}
          </Heading>
        </div>
        {mappedBanner?.image &&  
          <Image
            className={cn('justify-end flex flex-col self-end', mappedBanner?.imageClassName)}
            source={{ uri: mappedBanner?.image }}
          />  
        }
        <TouchableOpacity
          className="absolute right-0 top-0 p-2 xl:hidden"
          onPress={() => onClose?.()}>
            <img
              className="text-white rounded-lg p-1 w-6 h-6"
              src={close}
            />
        </TouchableOpacity>
      </TouchableOpacity>
  );
};
